/**
 * 支付SGM统一上报方法
 * 文档地址： https://joyspace.jd.com/pages/CP77Js6mFJq0FZAch28P
 */
import { reportSGM as reportSGMFn } from '@jdt-jinke/jdpay_utils'

export const isProduction = import.meta.env.VITE_BUILD_ENV === 'production'


/** 上报级别 */
export enum SGM_TYPE {
  Error = 1,
  Warn = 2,
  Info = 3,
}

/** SGM日志上报等级，高于当前等级的不上报 */
export const SGM_LOG_LEVEL = +import.meta.env.VITE_SGM_LOG_LEVEL || SGM_TYPE.Error


/*** 上报参数 */
export interface IReportSGMOptions {
  // 自定义编码: 应用（共用SGM应用的项目应传）_页面_触发类型（api、web、umd）_业务点标识_状态修饰符
  code: string

  // 日志类型: 默认值 'error'
  type?: SGM_TYPE

  // 设备类型: 无需手动上报，设备系统及App，类型和版本号
  device?: string

  // 用户流程ID: 无需手动上报，存放sessionStorage，结合插件会自动生成
  uuid?: string

  // 用户标识: 非pin时可传，如小程序的openid，默认空
  user?: string

  // 扩展描述: 可以放中文描述，方便搜索
  desc?: string

  // 接口地址、桥方法名称
  api?: string

  // 调用入参
  req?: string | Record<string, any>

  // 调用出参
  res?: string | Record<string, any> | any

  // 错误信息: 如果是Error类型对象如：catch中的error，上报方法会将err解析为message和stack。
  err?: unknown

  // 扩展参数
  ext?: string | Record<string, any>

  // 无需手动上报，上报时间毫秒
  time?: string | number

  // 目标应用的pid: 将日志上报到指定应用下。场景，例：前端组件、工具包监控
  pid?: string
}

/** 日志上报 */
export function reportSGM(options: IReportSGMOptions) {
  if (!options)
    throw new Error(`reportSGM missing required params: options: ${options}`)
  if (!isProduction) {
    options.code = options.code + '-DEV'
    options.type = SGM_TYPE.Info
  }

  const { code, err } = options

  reportSGMFn({
    err,
    ...options,
    code: `${import.meta.env.VITE_BIZ_CODE}_m_${code}`
  })
}
